const $body = $('body');

$body.on('click', '.js-dropdown--toggle', (event) => {
  const $this = $(event.currentTarget);
  const $dropdown = $this.parents('.js-dropdown');

  $dropdown.toggleClass('--active');
});

$body.on('click', '.js-dropdown--option', (event) => {
  const $this = $(event.currentTarget);
  const $dropdown = $this.parents('.js-dropdown');
  const $value = $dropdown.find('.js-dropdown--value');
  const $input = $($dropdown.data('input'));
  const value = $this.data('value');
  const html = $this.html();

  $value.html(html);
  $input.val(value);
});

$body.on('click', '.js-dropdown--checkbox', (event) => {
  const $this = $(event.currentTarget);
  const $dropdown = $this.parents('.js-dropdown');
  const $options = $dropdown.find('.js-dropdown--checkbox');
  const $value = $dropdown.find('.js-dropdown--value');
  const $input = $($dropdown.data('input'));
  const value = $this.data('value');

  const options = [];
  $options.each((index, element) => {
    const $element = $(element);

    if ($element.prop('checked')) {
      options.push($element.val());
    }
  });

  $value.html(options.join(', '));
  $input.val(value);
});
